import axios from 'axios'

export const getWarehouseList = () => {
  return axios
    .get('wms/warehouse')
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const postDraft = payload => {
  return axios
    .post('wms/inbound/draft', payload)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const postSubmit = payload => {
  return axios
    .post('wms/inbound/submit', payload)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getInboundList = (type, currentPage, perPage, filter) => {
  return axios
    .get(`wms/inbound/list/${type}/${currentPage}/${perPage}?${filter}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getInboundDetail = (id, filter) => {
  return axios
    .get(`wms/inbound/${id}?${filter}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const cancelInbound = id => {
  return axios
    .put(`wms/inbound/cancel/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const editSku = (id, formData) => {
  return axios
    .put(`wms/sku/${id}`, formData)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getInboundDocument = id => {
  return axios
    .get(`wms/inbound/document/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getInboundHistory = id => {
  return axios
    .get(`wms/inbound/history/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getInventoryList = (type, currentPage, perPage, filter) => {
  return axios
    .get(`wms/inventory/list/${type}/${currentPage}/${perPage}?${filter}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getInventoryDetail = (id, filter) => {
  return axios
    .get(`wms/inventory/${id}?${filter}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const moveStorage = (id, formData) =>
  axios
    .put(`wms/inventory/request-move-out/${id}`, formData)
    .then(res => res)
    .catch(err => {
      throw err.response
    })

export const getInventoryHistory = id => {
  return axios
    .get(`wms/inventory/history/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const downloadFileSKU = (skuId, fileId, fileName) => {
  return axios
    .get(`wms/sku/download-file/${skuId}/${fileId}`, { responseType: 'blob' })
    .then(res => {
      let blob = new Blob([res.data], { type: res.headers['content-type'] })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const downloadFileInventory = (
  fileId,
  fileName,
  url = 'wms/inventory/download-file/',
  type = ''
) =>
  axios
    .get(`${url}${fileId}/${type}`, { responseType: 'blob' })
    .then(res => {
      const blob = new Blob([res.data], { type: res.headers['content-type'] })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      throw err.response
    })

export const multipleSkuUpload = async formData => {
  try {
    const res = await axios.post(`wms/sku/upload-multiple-sku`, formData)
    return res
  } catch (err) {
    console.log('err', err, err)
    throw err.response
  }
}

export const supportingDocumentUpload = async (id, formData) => {
  try {
    const res = await axios.post(
      `wms/sku/upload-supporting-document/${id}`,
      formData
    )
    return res
  } catch (err) {
    console.log('err', err, err)
    throw err.response
  }
}

export const downloadOutStorageReport = (id, fileName) =>
  axios
    .get(`wms/inventory/download-out-storage-detail/${id}`, {
      responseType: 'blob'
    })
    .then(res => {
      const blob = new Blob([res.data], { type: res.headers['content-type'] })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      throw err.response
    })



// WEBPACK FOOTER //
// ./src/api/warehouse.api.js